import { randomBytes as cryptoRandomBytes } from './hash'

/**
 * 결과 주소(/r/{shortId})에 쓰는 식별자.
 *
 * 순번이나 짧은 id 를 쓰면 남의 결과를 훑을 수 있다. 그래서 추측이 불가능해야 한다.
 * 32글자 알파벳에서 16글자를 뽑으므로 경우의 수는 32^16 = 2^80 이다.
 * 헷갈리는 글자(I, L, O, U, 0, 1)는 뺐다. 사람이 주소를 받아 적을 수도 있어서다.
 */
const ALPHABET = '23456789ABCDEFGHJKMNPQRSTVWXYZ'
export const SHORT_ID_LENGTH = 16

/** 주소에 쓸 수 있는 형태인지 본다. 서버가 받은 값을 DB 에 넣기 전에 통과시킨다. */
const SHORT_ID_RE = new RegExp(`^[${ALPHABET}]{${SHORT_ID_LENGTH}}$`)

export function isValidShortId(value: string): boolean {
  return SHORT_ID_RE.test(value)
}

/**
 * 암호학적 난수로 만든다. Math.random 은 쓰지 않는다.
 * 브라우저와 Cloudflare Workers 모두 전역 crypto 를 제공한다.
 */
export function generateShortId(randomBytes: (n: number) => Uint8Array = cryptoRandomBytes): string {
  // 256 을 알파벳 길이로 나눈 나머지 때문에 생기는 쏠림을 없애려고, 범위를 넘는 바이트는 버린다.
  const limit = Math.floor(256 / ALPHABET.length) * ALPHABET.length
  let out = ''
  while (out.length < SHORT_ID_LENGTH) {
    for (const byte of randomBytes(SHORT_ID_LENGTH)) {
      if (byte >= limit) continue
      out += ALPHABET[byte % ALPHABET.length]
      if (out.length === SHORT_ID_LENGTH) break
    }
  }
  return out
}
